// src/services/api.js
import axios from 'axios'
import { isTokenValid, logout } from './auth.service'

/** =========
 * Token helpers (localStorage)
 * ========= */
const TOKEN_KEY = 'jwt_token'

export const tokenStore = {
  get() {
    return localStorage.getItem(TOKEN_KEY)
  },
  set(token) {
    localStorage.setItem(TOKEN_KEY, token)
  },
  clear() {
    localStorage.removeItem(TOKEN_KEY)
  }
}

/** =========
 * Axios instances
 * ========= */
const apiMovil = axios.create({
  baseURL: /*"https://localhost:7022"*/ process.env.VUE_APP_API_URL_MOVIL,
  headers: { 'Content-Type': 'application/json' },
  timeout: 15000
})

const apiWeb = axios.create({
  baseURL: /*"https://localhost:7022"*/ process.env.VUE_APP_API_URL_WEB,
  headers: { 'Content-Type': 'application/json' },
  timeout: 15000
})

/** =========
 * Helpers
 * ========= */
function isAuthRoute(url = '') {
  const normalizedUrl = String(url).toLowerCase()

  return normalizedUrl.includes('/login') || normalizedUrl.includes('/auth') || normalizedUrl.includes('/codigo')
}

/** =========
 * Interceptor: agrega Authorization si existe token
 * y valida expiración antes de enviar la petición
 * ========= */
function attachAuth(config) {
  const token = tokenStore.get()
  const requestUrl = config?.url || ''

  if (!token) {
    return config
  }

  if (!isAuthRoute(requestUrl) && !isTokenValid(token)) {
    logout()
    return Promise.reject(new Error('Sesión expirada.'))
  }

  config.headers = config.headers || {}
  config.headers.Authorization = `Bearer ${token}`

  return config
}

/** =========
 * Interceptor response:
 * si backend responde 401, cerrar sesión
 * ========= */
function handleResponseError(error) {
  const status = error?.response?.status

  if (status === 401) {
    logout()
  }

  return Promise.reject(error)
}

apiMovil.interceptors.request.use(attachAuth, (e) => Promise.reject(e))
apiWeb.interceptors.request.use(attachAuth, (e) => Promise.reject(e))

apiMovil.interceptors.response.use((response) => response, handleResponseError)
apiWeb.interceptors.response.use((response) => response, handleResponseError)

export { apiMovil, apiWeb }
